import CompassImage from 'assets/images/iconiq-compass-logo.png';
import DarkCompassImage from 'assets/images/iconiq-compass-dark-logo.png';
import Button from 'components/Button';
import { Link } from 'react-router';
import UserDropdown from 'components/UserDropdown';
import { useState } from 'react';
import BarChartIcon from 'assets/icons/bar-chart.svg';
import LogoutIcon from 'assets/icons/logout.svg';
import { useAuth } from 'context/AuthContext';
import Loader from 'components/Loader';
// import SettingsModal from 'components/SettingsModal';
// import SettingsIcon from 'assets/icons/settings.svg';
// import { IMockedUserData } from 'interfaces/components/settingsModal';

interface HeaderProps {
  toggleAboutModal: () => void;
  handleMyData?: () => void;
  // userData: IMockedUserData;
  // onUserDataUpdate: (data: IMockedUserData) => void;
}

const Header = ({
  toggleAboutModal,
  handleMyData
}:
// userData,
// onUserDataUpdate
HeaderProps) => {
  const [isDropdownOpen, setIsDropdownOpen] = useState(false);
  // const [isSettingsModalOpen, setIsSettingsModalOpen] = useState(false);
  const { isAuthenticated, username, signIn, signOut, isLoading } = useAuth();

  const handleSignIn = async () => {
    try {
      await signIn();
    } catch (error) {
      console.error('Sign in failed:', error);
    }
  };

  const handleSignOut = async () => {
    try {
      await signOut();
    } catch (error) {
      console.error('Sign out failed:', error);
    }
  };

  // const handleSettings = () => {
  //   setIsSettingsModalOpen(true);
  //   setIsDropdownOpen(false);
  // };

  // const handleSettingsSave = (data: {
  //   name: string;
  //   email: string;
  //   password: string;
  //   companyLogo: string;
  //   companyColor: string;
  // }) => {
  //   onUserDataUpdate(data);
  //   setIsSettingsModalOpen(false);
  // };

  const toggleDropdown = () => {
    setIsDropdownOpen(!isDropdownOpen);
  };

  const dropdownItems = [
    {
      icon: BarChartIcon,
      label: 'My Data',
      onClick: handleMyData || (() => {})
    },
    // {
    //   icon: SettingsIcon,
    //   label: 'Settings',
    //   onClick: handleSettings
    // },
    {
      icon: LogoutIcon,
      label: 'Logout',
      onClick: handleSignOut
    }
  ];

  return (
    <div className='bg-green-100 dark:bg-gray-900 px-20 py-5 flex items-center justify-between'>
      <Link to='/' className='border-none no-underline cursor-pointer'>
        <picture>
          <source
            srcSet={DarkCompassImage}
            media='(prefers-color-scheme: dark)'
          />
          <img src={CompassImage} alt='Logo' className='w-[170px]' />
        </picture>
      </Link>
      <div className='flex gap-8 items-center'>
        <span
          className='cursor-pointer text-base font-light'
          onClick={toggleAboutModal}
        >
          About
        </span>
        <a
          className='cursor-pointer text-base font-light border-none'
          href='https://www.iconiq.com/growth'
          target='_blank'
          rel='noreferrer noopener'
        >
          ICONIQ
        </a>
        {isAuthenticated ? (
          <UserDropdown
            isOpen={isDropdownOpen}
            onToggle={toggleDropdown}
            userName={username}
            items={dropdownItems}
          />
        ) : (
          <div className='flex gap-4'>
            {/* This is commented until check with the client if we need to have sign up button or sign in is enough*/}
            {/* <Button
              label={isLoading ? 'Signing In...' : 'Sign In'}
              onClick={handleSignIn}
              disabled={isLoading}
              className='cursor-pointer text-base font-semibold'
            /> */}
            <Button
              id='sign-in-button'
              label='Sign In'
              onClick={handleSignIn}
              disabled={isLoading}
              className='cursor-pointer text-base font-semibold px-[21px] py-[13px] bg-black text-white rounded-full leading-[10px]'
            />
          </div>
        )}
      </div>

      {/* <SettingsModal
        isOpen={isSettingsModalOpen}
        onClose={() => setIsSettingsModalOpen(false)}
        userData={userData}
        onSave={handleSettingsSave}
      /> */}

      <Loader isVisible={isLoading} />
    </div>
  );
};

export default Header;
